import React, { useState, useEffect, useRef } from 'react';
import SurveyService from '../../services/survey.service';
import PropTypes from 'prop-types';
import UserService from "../../services/user.service"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faMagnifyingGlass, faPlus, faPlusCircle, faRefresh, faSpinner } from "@fortawesome/free-solid-svg-icons"
import { CreditCard, Plus, User2Icon, X } from "lucide-react"

const AdminTherapistPatients = ({ therapistId }) => {

  const [users, setUsers] = useState(undefined);
  const [newUserList, setNewUsersList] = useState(undefined);

  const [loading, setLoading] = useState(false);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [loadingNewUsers, setLoadingNewUsers] = useState(false);

  const [error, setError] = useState('');
  const [searchTerm, setSearchTerm] = useState('')
  const debounceTimeoutRef = useRef(null);

  useEffect(() => {
    if (therapistId) {
      loadTherapistUsers();
    }
  }, [therapistId]);

  useEffect(() => {
    if (debounceTimeoutRef.current) {
      clearTimeout(debounceTimeoutRef.current);
    }

    if (searchTerm.length > 3) {
      debounceTimeoutRef.current = setTimeout(() => {
        setNewUsersList(undefined)
        searchNewUsers();
      }, 1500);
    }

    return () => {
      if (debounceTimeoutRef.current) {
        clearTimeout(debounceTimeoutRef.current);
      }
    };
  }, [searchTerm]);

  const loadTherapistUsers = async () => {
    try {
      setLoadingUsers(true);

      const res = await UserService.getTherapistUsers(therapistId);

      if (res?.length <= 0) {
        setUsers(undefined);
      } else {
        setUsers(res);
      }

      setError('');
    } catch (err) {
      console.error('Errore nel caricamento:', err);
    } finally {
      setLoadingUsers(false);
    }
  };

  const searchNewUsers = async () => {
    try {
      setLoadingNewUsers(true);

      const res = await UserService.getSearchUsers(searchTerm);

      if (res?.length <= 0) {
        setNewUsersList(undefined)
      } else {
        setNewUsersList(res);
      }

      setError('');
    } catch (err) {
      console.error('Errore nel caricamento:', err);
    } finally {
      setLoadingNewUsers(false);
    }
  };

  const associateTherapistsReq = async (userId) => {
    try {
      setLoading(true)

      const res = await UserService.associateTherapistAndUser(userId, therapistId);
      console.log('Risposte ricevute:', res);

      alert('Utente associato correttamente al terapista')
      loadTherapistUsers();
      setSearchTerm('')
      setNewUsersList(undefined)

      setError('');
    } catch (err) {
      console.error('Errore nel caricamento:', err);

      alert('Si è verificato un errore nell\'associazione');
    } finally {
      setLoading(false);
    }
  };

  const removeTherapistUserReq = async (userId) => {
    try {
      setLoading(true)

      const res = await UserService.removeTherapistUser(userId, therapistId);
      console.log('Risposte ricevute:', res);

      alert('Utente disassociato correttamente')
      loadTherapistUsers();

      setError('');
    } catch (err) {
      console.error('Errore nel caricamento:', err);

      alert('Si è verificato un errore nell\'associazione');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>

      {error && (
        <div className="mb-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded-md">
          {error}
        </div>
      )}

      {
        !loadingUsers ?
          <div className="bg-white p-6 rounded-lg shadow mb-6">
            <div>

              <h2 className={`text-lg font-semibold ${users && 'mb-4'}`}>
                {
                  users ?
                    'Pazienti associati al professionista'
                    :
                    'Nessun paziente associato al professionista'
                }
              </h2>

              {
                users &&
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Nome</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Cognome</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Email</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Telefono</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"></th>
                  </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                  {
                    users.map(item => (
                      <tr key={item.id} className="hover:bg-gray-50">
                        <td className="px-6 py-4 whitespace-nowrap">{item.user.first_name}</td>
                        <td className="px-6 py-4 whitespace-nowrap">{item.user.last_name}</td>
                        <td className="px-6 py-4 whitespace-nowrap">{item.user.email}</td>
                        <td className="px-6 py-4 whitespace-nowrap">{item.user.phone}</td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <button
                            disabled={loading}
                            onClick={() => removeTherapistUserReq(item.user_id)}
                            className={`text-red-600 hover:text-red-900 flex items-center ${loading ? 'opacity-50' : ''}`}
                            title="Cancella appuntamento"
                          >
                            <X className="w-4 h-4 mr-1"/>
                            Disassocia
                          </button>
                        </td>
                      </tr>
                    ))
                  }
                  <tr>
                    <td></td>
                  </tr>
                  </tbody>
                </table>
              }

            </div>
          </div>
          :
          <div className="bg-white p-6 rounded-lg shadow mb-6">
            <h2 className="text-lg font-semibold">Caricamento utenti associati...</h2>
          </div>
      }

      <div className="bg-white p-6 rounded-lg shadow">

        <h2 className="text-lg font-semibold mb-4">Associa nuovi pazienti</h2>

        <div className="mt-4 mb-4 relative">
          <input
            type="text"
            placeholder="Cerca per email..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full p-3 pl-10 border rounded-lg"
            disabled={loadingNewUsers}
          />
          <FontAwesomeIcon
            icon={faMagnifyingGlass}
            className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
          />
        </div>

        {
          loadingNewUsers &&
          <div className="flex justify-center items-center h-32">
            <p className="text-gray-500">Caricamento lista utenti</p>
          </div>
        }

        {
          (newUserList && !loadingNewUsers) &&
          <>
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Nome</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Cognome</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Email</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Telefono</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"></th>
              </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
              {
                newUserList.map(item => (
                  <tr key={item.id} className="hover:bg-gray-50">
                    <td className="px-6 py-4 whitespace-nowrap">{item.first_name}</td>
                    <td className="px-6 py-4 whitespace-nowrap">{item.last_name}</td>
                    <td className="px-6 py-4 whitespace-nowrap">{item.email}</td>
                    <td className="px-6 py-4 whitespace-nowrap">{item.phone}</td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {
                        !users?.some(user => user.user.id === item.id) ?
                          <button
                            disabled={loading}
                            onClick={() => associateTherapistsReq(item.id)}
                            className={`text-green-600 hover:text-green-900 flex items-center ${loading ? 'opacity-50' : ''}`}
                            title="Associa utente"
                          >
                            <Plus className="w-4 h-4 mr-1"/>
                            Associa
                          </button>
                          :
                          <span className="text-gray-500">Già associato</span>
                      }
                    </td>
                  </tr>
                ))
              }
              <tr>
                <td></td>
              </tr>
              </tbody>
            </table>
          </>
        }
      </div>

    </div>
  );
};

AdminTherapistPatients.propTypes = {
  therapistId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired
};

export default AdminTherapistPatients;
